import * as yup from "yup";

const schema = yup
  .object({
    fullName: yup
      .string()
      .required("Full name is required")
      .min(10, "Full name must be at least 10 characters"),
    email: yup.string().required("Email is required").email("Invalid email"),
    password: yup
      .string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),
    confirmPassword: yup
      .string()
      .required("Confirm password is required")
      .oneOf([yup.ref("password")], "Passwords must match")
  })
  .required();

export default schema;
